import { Notification, MessageBox, Message } from 'element-ui';
export default class Tips {
  static success(message = '', title = '', duration = 2000) {
    Notification({
      type: 'success',
      title: title,
      message: message,
      duration: duration
    });
  }

  static error(message = '', title = '', duration = 2000) {
    Notification({
      type: 'error',
      title: title,
      message: message,
      duration: duration
    });
  }

  static info(message = '', title = '', duration = 2000) {
    Notification({
      type: 'info',
      title: title,
      message: message,
      duration: duration
    });
  }

  static async confirm(message = '', title = '提示') {
    return await MessageBox.confirm(message, title, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
  }

  static message(message = '', type = 'info') {
    Message({
      message,
      type
    })
  }
}
